import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

// Sentry.init({
//   dsn: 'https://f66d6ef8e2cedf35b14cad2cda2de09a@o4507774493523968.ingest.de.sentry.io/4509581522042960',
//   integrations: [
//     // Registers and configures the Tracing integration,
//     // which automatically instruments your application to monitor its
//     // performance, including custom Angular routing instrumentation
//     Sentry.browserTracingIntegration(),
//     // Registers the Replay integration,
//     // which automatically captures Session Replays
//     Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
//   ],
//   environment: environment.production ? 'production' : 'development',
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for tracing.
//   // We recommend adjusting this value in production
//   // Learn more at
//   // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
//   tracesSampleRate: 1.0,

//   // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

//   // Capture Replay for 10% of all sessions,
//   // plus for 100% of sessions with an error
//   // Learn more at
//   // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
